import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  ADMIN_PROFILE_SETTINGS_ROUTE_NAME,
  AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME,
  PROFILE_SETTINGS_PERMISSIONS,
} from '@modules/profile-settings/constants';

import {
  ADMIN_PROFILE_SETTINGS_GENERAL_SETTINGS_ROUTE_NAME,
  AFFILIATE_PROFILE_SETTINGS_GENERAL_SETTINGS_ROUTE_NAME,
} from './constants';

export class ProfileSettingsGeneralModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_PROFILE_SETTINGS_ROUTE_NAME, {
      name: ADMIN_PROFILE_SETTINGS_GENERAL_SETTINGS_ROUTE_NAME,
      path: 'main',
      permission: PROFILE_SETTINGS_PERMISSIONS.SHOW,
      component: () => import('./pages/GeneralSettingsPage/GeneralSettingsPage.vue'),
    });

    router.addChildRoute(AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME, {
      name: AFFILIATE_PROFILE_SETTINGS_GENERAL_SETTINGS_ROUTE_NAME,
      path: 'main',
      permission: PROFILE_SETTINGS_PERMISSIONS.SHOW,
      component: () => import('./pages/GeneralSettingsPage/GeneralSettingsPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
